module.exports = __webpack_public_path__ + "img/nav4.a333c03d.png";